import React from 'react';
import { Smartphone, Mail, MapPin, Search, Zap, Shield, MessageCircle, Star, Layout, CheckCircle } from 'lucide-react';
import { Badge } from '../ui/badge';
import { mockData } from '../../mock';

const iconMap = {
  'smartphone': Smartphone,
  'mail': Mail,
  'map-pin': MapPin,
  'search': Search,
  'zap': Zap,
  'shield': Shield,
  'message-circle': MessageCircle,
  'star': Star,
  'layout': Layout,
  'check-circle': CheckCircle
};

const WhatsIncludedSection = () => {
  return (
    <section className="relative py-32 px-6 bg-gradient-to-b from-[#0a0a0a] via-[#0B0F1A] to-[#111111] overflow-hidden">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#3B82F6]/5 rounded-full blur-[120px] pointer-events-none"></div>
      
      <div className="container mx-auto max-w-7xl relative z-10">
        <div className="text-center mb-20">
          <Badge className="inline-flex items-center justify-center px-4 py-1.5 bg-gradient-to-r from-[#2F6BFF]/10 to-[#4DA3FF]/10 text-[#2F6BFF] border border-[#2F6BFF]/20 rounded-full text-sm font-medium mb-6 hover:from-[#2F6BFF]/20 hover:to-[#4DA3FF]/20 transition-all duration-300">
            Features Included
          </Badge>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-white">Everything You Need</h2>
          <p className="text-[#9AA3B2] text-lg md:text-xl max-w-3xl mx-auto">
            Professional features to help your business stand out online
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
          {mockData.whatsIncluded.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <div 
                key={feature.id}
                className="group relative"
                style={{
                  animation: `fadeInUpStagger 0.6s ease-out forwards`,
                  animationDelay: `${index * 0.05}s`,
                  opacity: 0
                }}
              >
                {/* Glow effect on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-[#3B82F6]/0 to-[#3B82F6]/0 group-hover:from-[#3B82F6]/10 group-hover:to-[#2F6BFF]/5 rounded-2xl blur-xl transition-all duration-500 opacity-0 group-hover:opacity-100"></div>
                
                {/* Card */}
                <div className="relative flex flex-col items-center text-center p-6 md:p-8 rounded-2xl bg-gradient-to-br from-[#1a1a1a]/80 to-[#0f0f0f]/60 border border-white/5 hover:border-[#3B82F6]/40 transition-all duration-500 backdrop-blur-sm group-hover:scale-105 group-hover:shadow-2xl group-hover:shadow-[#3B82F6]/10">
                  {/* Icon container */}
                  <div className="relative w-16 h-16 md:w-20 md:h-20 rounded-xl bg-gradient-to-br from-[#3B82F6]/20 via-[#2F6BFF]/10 to-transparent flex items-center justify-center mb-4 group-hover:rotate-6 transition-all duration-500 overflow-hidden">
                    {/* Animated shine effect */}
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></div>
                    <Icon className="h-8 w-8 md:h-10 md:w-10 text-[#3B82F6] group-hover:text-[#60A5FA] transition-colors duration-300 relative z-10" />
                  </div>
                  
                  {/* Feature title */}
                  <p className="text-white text-sm md:text-base font-semibold leading-tight group-hover:text-[#60A5FA] transition-colors duration-300">
                    {feature.title}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhatsIncludedSection;
